//import { userConstants, alertConstants, commonConstants, notificationConstants } from '../constants';
import { API_FETCH } from '../config';



// -------------- USER Page --------------
export const USER_FIELD_ERROR = 'USER_FIELD_ERROR';
export const USER_FIELD_RESET_ERROR = 'USER_FIELD_RESET_ERROR';
export const USER_STATE_RESET = 'USER_STATE_RESET';
export const USER_STATE_RECENT_ADD = 'USER_STATE_RECENT_ADD';
export const USER_RESET_ITEM = 'USER_RESET_ITEM';
export const USER_SET_ITEM = 'USER_SET_ITEM';
export const USER_GET_ITEM = 'USER_GET_ITEM';
export const USER_SET_ALL = 'USER_SET_ALL';
export const USER_SET_ALL_FOR_EXCEL = 'USER_SET_ALL_FOR_EXCEL';
export const USER_ADD_ITEM = 'USER_ADD_ITEM';
export const USER_ADD_SETTLE_ITEM = 'USER_ADD_SETTLE_ITEM';
export const ADD_COMMENT_ITEM = 'ADD_COMMENT_ITEM';
export const GET_COMMENT_ITEM = 'GET_COMMENT_ITEM';
export const USER_ID  = 'USER_ID';

// -------------- PERMISSION Page --------------
export const PERMISSION_SET_ITEM = 'PERMISSION_SET_ITEM';
export const PERMISSION_GET_ITEM = 'PERMISSION_GET_ITEM';

// --------- USER Page ---------
export function userFieldError(field, fieldData = {}) {
    return { type: USER_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function userFieldResetError(field, fieldData = {}) {
    return { type: USER_FIELD_RESET_ERROR }
}
export function userSetItem(targetItem) {
    return { type: USER_SET_ITEM, data: targetItem }
}
export function userGetItem(getItem) {
    return { type: USER_GET_ITEM, data: getItem }
}
export function userAddItem(addItem) {
    return { type: USER_ADD_ITEM, data: addItem }
}
export function userAddSettleItem(addItem) {
    return { type: USER_ADD_SETTLE_ITEM, data: addItem }
}
export function userId(userId) {
    return { type: USER_ID, data: userId}
}
export function userSetList(allUSER) {
    return { type: USER_SET_ALL, data: allUSER }
}
export function userSetListForExcel(allUSER) {
    return { type: USER_SET_ALL_FOR_EXCEL, data: allUSER }
}
export function addCommentItem(addItem) {
    return { type: ADD_COMMENT_ITEM, data: addItem }
}
export function getCommentItem(Item) {
    return { type: GET_COMMENT_ITEM, data: Item }
}
// --------- PERMISSION Page ---------
export function permissionSetItem(targetItem) {
    return { type: PERMISSION_SET_ITEM, data: targetItem }
}
export function permissionGetItem(getItem) {
    return { type: PERMISSION_GET_ITEM, data: getItem }
}
